import { Navigator } from "../../main_components/navigator.js";
import Styles from "./media.module.css";
import { MediaHeader, Media } from "./media_components.js";
import test1Img from "../../images/11905945_4857949.jpg";
import test2Img from "../../images/88805032_DJV MAR 1045-01.jpg";
import test3Img from "../../images/66243604_9603059.jpg";
import test4Img from "../../images/34479554_8123745.jpg";
import { useState } from "react";
export const MediaBody = ( props ) => {
    const {  } = props;
    const { Body, Content } = Styles;
    const [ filter, setFilter] = useState("All");
    const media = [
        { image: test1Img, imageTheme: "#ffc107", filesNumber: "12 files", size: "3GB", cost: "FREE", name: "Test Medium", nameTheme: "#607d8b", link: "/view_list", category: "programming" },
        { image: test2Img, imageTheme: "#009688", filesNumber: "12 files", size: "3GB", cost: "FREE", name: "Test Medium", nameTheme: "#795548", link: "/view_list", category: "math" },
        { image: test3Img, imageTheme: "#2196f3", filesNumber: "12 files", size: "3GB", cost: "FREE", name: "Test Medium", nameTheme: "#ff9800", link: "/view_list", category: "media" },
        { image: test4Img, imageTheme: "purple",  filesNumber: "12 files", size: "3GB", cost: "FREE", name: "Test Medium", nameTheme: "#ff5722", link: "/view_list", category: "films" },
        { image: test1Img, imageTheme: "#ffc107", filesNumber: "12 files", size: "3GB", cost: "FREE", name: "Test Medium", nameTheme: "#607d8b", link: "/view_list", category: "programming" },
        { image: test2Img, imageTheme: "#009688", filesNumber: "12 files", size: "3GB", cost: "FREE", name: "Test Medium", nameTheme: "#795548", link: "/view_list", category: "math" },
        { image: test3Img, imageTheme: "#2196f3", filesNumber: "12 files", size: "3GB", cost: "FREE", name: "Test Medium", nameTheme: "#ff9800", link: "/view_list", category: "media" },
        { image: test4Img, imageTheme: "purple",  filesNumber: "12 files", size: "3GB", cost: "FREE", name: "Test Medium", nameTheme: "#ff5722", link: "/view_list", category: "films" },
    ];
    const headlines = [
        "Explore Our Media Today!",
        "Discover Our Media Collection!",
        "Explore Our Media!",
        "Explore Our Media Offerings!",
        "Discover Our Diverse Media!",
    ];
    return (
        <main className={ Body }>
            <Navigator page={ "Media" }/>
            <main className={ Content }>
                <MediaHeader 
                    setFilter = { setFilter }
                    headlines = { headlines }
                />
                <Media 
                    media  = { media.reverse() }
                    filter = { filter          }
                />
            </main>
        </main>
    );
};